import { patch, post } from './api';
import URLS from '@/constants/api';

export const changeProfile = async (data: any) => {
  const response = await patch(URLS.CHANGE_PR0FILE_SETTINGS, data);
  return response;
};
